import { market } from "../market/ru";
import { invite } from '../invite/ru';
import { property } from '../property/ru';
import {advertise} from '../advertise/ru';
import {login, download} from '../login/ru';
import {trading} from '../trading1/ru';
import { contest } from "../contest/ru";
import { merchandiser, common, tableList, dialog, codeInfo, hyy as contractHyy, placeOrder, codelist, panKou } from "../merchandiser/ru";
import { games } from '../games/ru';
import { taskCenter } from "../task/ru";
import { ieo } from "../ieo/ru";
import { earn } from "../earn/ru";
import { tradingContest } from "../tradingContest/ru";
import { agent } from "../agent/ru";
import { live } from "../live/ru";
import { hongbao } from "../hongbao/ru";

const time = {
  r: "дн.",
  s: "ч",
  f: "мин",
  m: "сек",
};

// Состояния
const state = {
  preheatIng: "Разогрев",
  purchaseIng: "В процессе покупки",
  over: "Завершено",
  finish: "Завершено",
  noData: "Нет данных",
  process: "В процессе поддержки",
  sellout: "Распродано",
};

// Текстовые шаблоны
const text = {
  now: "В процессе",
  start: "До начала раунда",
  end: "До окончания раунда",
  jd: "Прогресс раунда",
  complete: "Завершено",
  limited: "Цена со скидкой",

  finish: "Завершено",
  subscribing: "Подписка",
  subscribeNow: "Подписаться сейчас",
  buyStart: "До начала подписки",
  buyEnd: "До окончания подписки",
  projectAmount: "Количество проектов",
  quota: "Лимит на один проект",
  buyPrice: "Цена подписки",
  buyLimit: "Лимит подписки",
  buyAmount: "Количество подписки",
  buyPos: "Остаток монеты для подписки",
  startDate: "Дата начала",
  endDate: "Дата окончания",
  projectSuppot: "Поддержка проекта",
  websit: "Сайт проекта",
  projectDetail: "Детали проекта",
  cycle: "Период подписки",
  all: "Все",
  step1: "Разогрев",
  step2: "Подписка",
  step3: "Жеребьёвка",
  step4: "Объявление результатов",
  subOrder: "Ордер подписки",
  myOrder: "Выигравшие ордера",
  proCoin: "Монета проекта",
  buyCoin: "Монета подписки",
  orderDate: "Время ордера",
  issuanceQuota: "Выделенный лимит",
  dealAmount: "Исполненное количество",
  dealPrice: "Сумма исполнения",
  status: "Статус",
  ctrl: "Действие",
  checkOrder: "Просмотр билетов",
  subNum: "Номер билета подписки",
  myNum: "Выигравший билет",
  status0: "Подписано",
  status1: "Ожидание списания",
  status2: "Завершено",
  conditionTerm1: "За * дней до начала подписки, ",
  conditionTerm2: "Торговая пара *",
  conditionTerm3: "Все торговые пары",
  conditionTerm4: "За каждые * USDT совокупного спот-объёма можно подписать 1 лот",
  noData: "Нет данных",
  qgsc: "Блокировка при покупке",
  yhsg: "Жеребьёвка",
  sgsb: "Ошибка подписки",

  supply: "Лимит раунда",
  rate: "Курс обмена",
  ceiling: "Лимит поддержки",
  xmwc: "Проект завершён",
  xmze: "Общая сумма проекта",
  zkjj: "Средняя цена со скидкой",
  cyrs: "Количество участников",
  round: "Раунд [*]",
  r: "чел.",
  cgqg: "Успешно куплено",
  cgzl: "Успешно поддержано",
  xmed: "Лимит проекта",
  kszl: "Время начала поддержки",
  ksqg: "Время начала покупки",
  jsqg: "Время окончания покупки",
  jszl: "Время окончания поддержки",
  hdgz: "Правила акции",
  xmjs: "Описание проекта",
  tcqr: "Если вы выйдете с подтверждения оплаты, вы можете потерять возможность участия в этой акции. Будьте осторожны!",
  jxtc: "Продолжить выход",
  fhzf: "Вернуться к оплате",
  qgrsd: "Много участников, пожалуйста, подождите!",
  zltcqr: "Если вы выйдете с подтверждения оплаты, вы можете потерять возможность участия в акции поддержки.",
  zlqgrsd: "Много участников поддержки, пожалуйста, подождите!",
  wxts: "Внимание: подтвердите оплату как можно скорее, иначе через [*] минут окно закроется.",
};

const seckill = {
  sgno: "Вы не соответствуете условиям подписки",
  srjymm: "Введите торговый пароль",
  ljzf: "Оплатить сейчас",
};

const apply = {
  condition: "Условия подписки",
  apply: "Подписаться сейчас",
  buyPrice: "Цена подписки",
  buyAmount: "Количество подписки",
  applyAmount: "Сумма подписки",
  forget: "Забыли пароль?",
  noAmount: "Введите количество подписки",
  buyLimit: "Лимит подписки",
  success: "Подписка успешна!",
  paySummary: "Внимание: подтвердите оплату в течение <b>3 минут</b>, иначе окно закроется.",
  appFull: "Слишком большое количество подписки",
  seckill_async_fail_13: "Интервал между двумя подписками: {} минут",
};

const seckillRes = {
  seckill_async_3: "Оплата обрабатывается, подождите!",
  seckill_async_5: "Отмена успешна",
  seckill_async_fail_1: "Ошибка! Обновите страницу и попробуйте снова!",
  seckill_async_fail_2: "Ошибка! Обновите страницу и попробуйте снова!",
  seckill_async_fail_3: "Ошибка! Обновите страницу и попробуйте снова!",
  seckill_async_fail_4: "Извините, лимит выбран!",
  seckill_async_fail_5: "Извините, время оплаты истекло, попробуйте снова!",
  seckill_async_fail_6: "Неверный пароль, попробуйте снова!",
  seckill_async_fail_7: "Лимит неверных попыток пароля превышен, попробуйте позже!",
  seckill_async_fail_8: "Извините, оплата просрочена, попробуйте снова!",
  seckill_async_fail_9: "Извините, лимит выбран, удачи в следующий раз!",
  seckill_async_fail_10: "Слишком много участников, попробуйте позже!",
  seckill_async_fail_11: "Ошибка проверки поведения!",
};

const header = {
  zcgl: "Управление активами",
  zczh: "Аккаунт активов",
  bbzh: "Спот-счёт",
  fbzh: "Счёт покупки (фиат)",
  bdbzh: "Крипто-кредит",
  wdgl: "Управление ордерами",
  lswt: "История ордеров",
  qbhz: "Перевод между счетами",
  yhzx: "Центр пользователя",
  wdhb: "Мои бонусы",
  openOrder: "Активные ордера",
  dealStats: "Статистика сделок",
  totalAsset: "Общая стоимость активов",
  cz: "Фьючерсный счёт",
  gmcnyt: "Купить CNYT",
  yqfy: "Реферальная программа",
  hbthhr: "Партнёр HBT",
  tczh: "Выйти",
  moreNew: "Другие объявления",
  gfgg: "Официальные объявления",
  zxxw: "Новости",
  ckgd: "Показать больше",
  bbdd: "Спот-ордера",
  bbwhydd: "Ордера бессрочных контрактов",
  etfdd: "Ордера ETF",
  fbdd: "Фиат-ордера",
};

const recommend = {
  vol24h: "Объём 24ч",
  jyd: "Пара",
  jydlx: "Тип пары",
  zxj: "Последняя цена",
  change24: "24ч изм.",
  line24: "Тренд цены (3 дня)",
};

const hyy = {
  bkt: "Не открывать",
  wqdkt: "Открыть",
  kt12: "1. До участия вы должны детально изучить основы и риски торговли контрактами, а также правила платформы.",
  kt13: "2. Данный список рисков не является исчерпывающим. Дополнительно оцените иные возможные риски.",
  kt14: "3. Мы рекомендуем вам оценить свою устойчивость к риску и принять взвешенное решение о торговле.",
  kt0: "Уважаемый пользователь:",
  kt1: "У вас ещё нет фьючерсного счёта. Пожалуйста, внимательно прочитайте следующее перед открытием:",
  kt2: "1. При недостатке маржи может произойти принудительная ликвидация позиции BiKing.",
  kt3: "2. Вы должны изучить правила и механизмы работы бессрочных контрактов BiKing.",
  kt4: "3. Позиции переоцениваются в зависимости от рынка. При значительном убытке может произойти ликвидация. Вы несёте ответственность за свои сделки.",
  kt5: "4. Пожалуйста, соблюдайте правила платформы и местное законодательство. При нарушении счёт будет заморожен, и платформа не сможет закрыть позиции. BiKing не несёт ответственности за убытки.",
  kt6: "5. Существуют регуляторные риски. Изучите законодательство своей юрисдикции. Возможны изменения правил.",
  kt7: "6. Неплатформенные риски (форс-мажор, сбои связи) могут повлиять на исполнение ордеров.",
  kt8: "7. Хеджирование также сопряжено с ценовыми рисками.",
  kta9: "8. Отсутствие верификации или передачи аккаунта может повлиять на безопасность маржи.",
  kta10: "3. В экстремальных рыночных условиях (например, при лидерстве по P&L и недостатке страхового фонда) закрытие позиции может быть недоступно.",
  kt9: "Я внимательно прочитал и принимаю риски",
  kt10: "Активировать фьючерсный счёт",
  zjhz: "Перевод средств",
  ljhz: "Перевести",
  qx: "Отмена",
  khz: "Доступно для перевода",
  qxz: "Выберите",
  bz: "Монета",
  c: "С",
  zz: "На",
  sl: "Количество",
  qb: "Всё",
  ktcg: "Активация успешна",
  ktsb: "Ошибка активации",
  hzcg: "Перевод успешен",
  hzsb: "Ошибка перевода",
  wyyd: "", // не заполнено предупреждение о прочтении
  tc: "Выйти",
  warning1: "Выберите монету",
  warning2: "Счёт отправления не может быть пустым",
  warning3: "Счёт назначения не может быть пустым",
  warning4: "Введите сумму не более доступной",
  warning5: "Максимум 4 знака после запятой",
  gb: "Закрыть",
  openSuccess: "Фьючерсный счёт активирован",
  openSuccessTip: "Переведите средства на фьючерсный счёт",
  wsmyz: "Вы не прошли верификацию",
  hdnm: "Пройдите верификацию и внесите чистыми [*] USDT, чтобы получить [**] USDT бонуса",
  nmjl: "История бонусов",
  nmhzjl: "История полученных бонусов",
  gxn: "Поздравляем!",
  qwjy: "К торговле",
  yfrndhyzh: "Зачислено на ваш фьючерсный счёт",
  nzxy: "Вам осталось перевести [*] USDT на фьючерсный счёт, чтобы получить [**] USDT бонуса",
  nmssm: "Что такое бонус?",
  nm: "Бонус",
  nxhyzh: "На ваш фьючерсный счёт",
  text1: "Чистым переводом на фьючерсный счёт [*] USDT и более, вы получаете",
  text2: "Вам осталось перевести [*] USDT",
  text3: "чтобы получить [*] USDT бонуса",
  text4: "Баланс",
  text5: "Чистым переводом на фьючерсный счёт [*] USDT и более, вы получили",
  not_get_nm: "К сожалению, акция с бонусами завершена, при переводе бонус не начислен.",
  yijie: "1. Уровень 1",
  erjie: "2. Уровень 2",
  ljjhr: "Чистый перевод",
  khd: "Можно получить",
  hysnm: "Фьючерсный бонус",
  bbgg: "Бессрочный контракт, 100x плечо",
  hdsj: "Время акции:",
  hdxq: "Детали акции",
  ljhd: "Получить сейчас",
  xdxd: "Кто успел, тот и съел",
  ylnnz: "Выиграл — забирай, проиграл — мой счёт",
};

const Verification = {
  channel: "Официальный канал верификации",
  verify: "Введите информацию для проверки",
  notes: "Важно",
  notes1: "1. Все email, WeChat, QQ, домены и соцсети Biking можно проверить здесь.",
  notes2: "2. Соцсети (Twitter и др.) поддерживают только поиск по имени, с учётом регистра.",
  notes3: "3. При сомнениях обратитесь к официальной поддержке.",
  error: "Ошибка верификации",
  error1: "Информация",
  error2: "не является официальным каналом. Будьте осторожны, защищайте свои активы.",
  errorNote: "Внимание",
  errorNote1: "1. Сейчас верифицируются только email, WeChat, QQ, домены и соцсети",
  errorNote2: "2. В WeChat и др. поддерживается только аккаунт (не никнейм)",
  errorNote3: "3. Соцсети — только по имени, с учётом регистра",
  success: "Верификация успешна",
  success1: "Информация:",
  success2: "является официальным каналом Biking",
  success3: " — другие каналы не заслуживают доверия.",
  more: "Подробнее",
  know: "Понятно",
  weChat: "WeChat",
  name: "Домен",
  webo: "Weibo",
  twitter: "Twitter",
  email: "Email",
  contact: "Связаться с поддержкой",
  bannerTip: "Чтобы не стать жертвой мошенников, проверяйте через эту страницу контакты звонящих или пишущих вам.",
};

const index = {
  downloadIos: 'Скачать AppStore',
  downloadAndroid: 'Скачать Android',
  downloadGoogle: 'Скачать Google Play'
};

const indexPage = {
  gfgg: "Официальные объявления",
  zxxw: "Новости",
  ckgd: "Показать больше",
};

const NAVS = {
  ty: 'Евро-2024',
  hqsj: 'Рынок',
  game: 'Игры',
  fx: 'Обзор',
  sj: 'Данные',
  fb: "Купить",
  bb: "Спот",
  jr: "Финансы",
  jyds: "Турнир",
  hbhd: "Акция с конвертами",
  gg: "Маржинальная торговля",
  yxhy: "Бессрочный контракт",
  eft: "ETF",
  flhd: "Акции",
  flzx: "Центр акций",
  fast: "Быстрая торговля",
  spec: "Профессиональная торговля",
  login: "Войти",
  rig: "Регистрация",
  downapp: "Скачать BiKing APP",
  downappsum: "Плавно, быстро",
  zichan: "Активы",
  order: "Ордера",
  qbhz: "Перевод",
  lang: "Язык",
  calc: "Валюта",

  mb: "Купить",
  hq: "Рынок",
  hy: "Фьючерс",
  jy: "Торговля",
  lc: "Заработок",
  fs: "Fansup",
  xy: "Академия",
  byxy: "Академия BiKing",
  byyx: "Выбор BiKing",
  coins: "COINS",
  gd: "Ещё",
  yqhy: "Пригласить друга",
  rwzx: "Центр заданий",
  bbms: "Купить BTC и др. за USDT",
  ggms: "Маржинальная торговля",
  yxms: "Удобно, 100x плечо",
  etfms: "Без риска ликвидации",
  pool: "Майнинг-пул",
  czzn: 'Руководство',
  gywm: 'О нас',
  zhxx: 'Данные аккаунта',
  gd: "Копитрейдинг",
  yxhy: "Бессрочный контракт",
  zjhy: "Бонусный контракт",
  product: "Продукты",
};

const FOOTERS = {
  zxkf: "Поддержка",
  fawu: "Юридическая консультация",

  us: "О нас",
  product: "Продукты",
  service: "Сервис",
  college: "Обучение",

  aboutUs: "О компании",
  rateSum: "Комиссии",
  notices: "Объявления",
  helps: "Помощь",
  verific: "Верификация каналов",
  contact: "Контакты",

  fabi: "Купить",
  bibi: "Спот",
  ganggan: "Маржинальная торговля",
  swiper: "Бессрочный контракт",
  etf: "ETF",
  licai: "Заработок",

  apis: "API",
  apisNew: "API",
  addCoin: "Заявка на листинг",
  vips: "VIP",
  downapp: "Скачать APP",
  files: "Документы",

  newuser: "Для новичков",
  swiperSchool: "Академия контрактов",
  assistant: "Помощник",
  digitalintroduction: "Что такое криптовалюта",

  watchword: "Мировая зелёная платформа",
  meiyitian: "Богатство каждый день",
  chat: "Чат",
  shequncn: "Telegram (Китай)",
  shequnen: "Telegram (Англ.)",
  shequnkr: "Telegram (Кор.)",
};

const SIDEBAR = {
  newuser: "Новичок",
  guide: "Гид",
  bbsq: "Сообщество спот",
  hysq: "Сообщество фьючерс",
  gd: "Фикс.",
  sq: "Свернуть",
};

const banner = {
  wzwh: 'Используя сайт и/или обслуживая аккаунт, вы соглашаетесь с обновлёнными',
  sytk: 'Условиями пользования',
  yszc: 'Политикой конфиденциальности',
  cookie: 'Политикой cookie',
  hh: 'и',
  djgb: 'Нажимая «X», вы подтверждаете, что прочитали и приняли вышеуказанные условия и политики.',

  title: 'Многофункциональная игровая платформа и платформа для торговли цифровыми валютами',
  marketTitle: 'Торговля цифровыми валютами — наше призвание',
  marketSubTitle: 'Мы стремимся обеспечивать более безопасную и стабильную торговлю крипто-деривативами',
  pathTitle: 'Ваш надёжный помощник в мире цифровых валют',
  pathSubTitle: 'Выбор миллионов. Платформа, которой доверяют',
  jylz: '300 млрд USD',
  jyl: 'Объём за 72 часа',
  sxs: 'Криптовалют в листинге',
  zcyh: 'Зарегистрировано пользователей',
  zdjy: 'Минимальная комиссия',
  connectTitle: 'Почему выбирают нас',
  connectSubTitle: 'BiKing помогает создавать, приумножать и защищать ваше богатство',
  advantageText1: 'Высокая производительность · Мгновенные сделки',
  advantageSubText1: 'Технология Лондонской фондовой биржи, сверхнизкая задержка, быстрое сопоставление ордеров',
  advantageText2: 'Безопасность активов · Максимальная защита',
  advantageSubText2: 'BiKing соответствует стандарту CCSS, гарантируя безопасность активов и данных',
  advantageText3: 'Высокая ликвидность · Низкий спред',
  advantageSubText3: 'Сверхэффективная торговля, минимальное проскальзывание',
  advantageText4: 'Круглосуточная поддержка',
  advantageSubText4: 'Обеспечение бесперебойной работы системы и предоставление круглосуточной поддержки',
  advantageText5: 'Удобство и простота',
  advantageSubText5: 'Различные типы ордеров и инструментов, риск под контролем',
  advantageText6: 'Торгуйте где угодно и когда угодно',
  advantageSubText6: 'BiKing доступен на веб-сайте, в мобильном приложении, через API и FIX',
  netWorkTitle: 'Выбор 1,2 млн пользователей из 26 стран',
  netWorkSubTitle: 'Мы стремимся обеспечить более безопасную и стабильную платформу для торговли крипто-деривативами',
  smxz: 'Сканируйте для загрузки',
  fxbzj: 'Страховой фонд',
  fkbz: 'Каждая сделка под защитой от рисков',
  question1: '1. О бирже BiKing',
  questionContent1: 'BiKing — ведущая сингапурская платформа для торговли цифровыми активами, имеет лицензии MSB США и Канады, предоставляет услуги по торговле, хранению и управлению активами.',
  question2: '2. Какие продукты предлагает BiKing?',
  questionContent2: 'BiKing предлагает: бессрочные контракты, спот (0 комиссии), копитрейдинг, бонусную торговлю (специальный режим), веб-кошелёк (децентрализованный).',
  question3: '3. Как зарегистрироваться на BiKing?',
  questionContent3: 'Вы можете зарегистрироваться на официальном сайте или в приложении BiKing. Процесс регистрации прост.',
  question4: '4. Как купить криптовалюту через BiKing?',
  questionContent4: 'Быстрая покупка криптовалюты поддерживает множество платёжных методов и фиатных валют, что удобно для пользователей по всему миру.',
  question5: '5. Как торговать цифровыми активами?',
  questionContent5: 'Выберите актив, перейдите на страницу торговли, выберите покупку или продажу, введите количество и цену, подтвердите сделку. Доступно множество активов: BTC, ETH, LTC, XRP и др.',
  question6: '6. Как BiKing обеспечивает безопасность активов?',
  questionContent6: 'BiKing использует многоуровневое шифрование, а также холодное и горячее хранение средств.',

  investor: 'Которым доверяют 3 миллиона инвесторов',
  transaction: 'Инвестируйте, торгуйте и развивайтесь с BiKing',
  hypt: 'Безопасная фьючерсная платформа',
  yjpc: 'Один клик — открыть/закрыть',
  jscrj: 'Быстрый ввод/вывод, 60 секунд до начала торгов, нулевое проскальзывание',
  zcpt: 'Зарегистрируйтесь и получите USDT',
  email: 'Email',
  phone: 'Телефон',
  zc: 'Регистрация',
  yhjaqbz: 'Банковский уровень безопасности',
  lhdmch: '0 проскальзывание, мгновенное исполнение',
  qthkf: '7×24 поддержка',
  rmjmhb: 'Популярные криптовалюты',
  jrsq: 'Присоединяйтесь к сообществу Biking',
  hqzxhd: 'Будьте в курсе новостей акций и получайте онлайн-поддержку',
};

const navCard = {
  join: 'Присоединяйтесь к BiKing',
  hzdl: 'BiKing приглашает агентов и партнёров',
  jmrx: 'Горячая линия: 183283232998',
  contract: 'Контракты онлайн',
  yxhy: 'Срочные контракты BiKing выходят на рынок',
  jylh: 'Больше гибкости, больше выгоды',
  usa: 'Лицензии MSB США и Канады',
  zmjys: 'BiKing получил лицензии в нескольких странах',
  fxpf: 'Риск под защитой, безопасность превыше всего',
  srhy: '30% реального вознаграждения за фьючерсы',
  hdsj: 'Акция с 01.11.2022 по 01.12.2022',
};

const choice = {
  gjyh: 'Выбор 1,2 млн пользователей из 26 стран',
  jyfu: 'Мы стремимся обеспечить более безопасную и стабильную торговлю крипто-деривативами',
  wsmxzwm: 'Почему выбирают нас',
  jsty: 'Мгновенный опыт',
  jmsj: 'Интерфейс торговли основан на многолетнем опыте пользователей, процесс чёткий и удобный, с микросекундным движком сопоставления ордеров.',
  kfx: 'Механизм устойчивости к риску',
  pthybz: 'Цена контрактов формируется по мульти-индексному алгоритму, что обеспечивает надёжную защиту от резких движений рынка.',
  zjaqbz: 'Гарантия безопасности средств',
  zjdt: 'Все переводы средств подписываются многократно офлайн, глубокая холодная защита активов, 100% банковский уровень безопасности.',
  jszc: 'Техническая поддержка высшего уровня',
  ptjstd: 'Команда разработчиков состоит из ведущих экспертов в области блокчейна.',
  jcjz: 'Механизм ступенчатого уменьшения позиции',
  hqbh: 'Адаптивная система контроля рисков 24/7.',
  kf: '24/7 Поддержка',
  ptkf: 'Круглосуточная поддержка пользователей.',
};

const plat = {
  ptgn: 'Функции платформы',
  zjms: 'Бонусный режим',
  zjjs: 'Бонусный режим — уникальная особенность BiKing. Прибыль от бонусных средств можно перевести на фьючерсный счёт для дальнейшей торговли или вывести.',
  zcms: 'Режим Cross',
  zcjs: 'В режиме Cross маржа и плавающий P&L всех позиций объединены. Сильный контроль риска, но при резком движении рынка возможен убыток.',
  zucms: 'Режим Isolated',
  zucjs: 'Каждая позиция независима. При достижении стоп-лосса позиция закрывается. При активных позициях/ордерах переключение режима невозможно.',
  gdgn: 'Копитрейдинг',
  gdjs: 'После активации все действия ведущего синхронизируются, если достаточно средств. Копирование продолжается до отмены вручную.',
  bfpc: 'Частичное закрытие',
  bfjs: 'Позволяет свободно выбрать сумму для закрытия части позиции. Прибыль/убыток пересчитывается пропорционально.',
  fxkc: 'Реверс позиции',
  fxjs: 'Система автоматически закрывает текущую позицию по лучшей цене и открывает позицию того же объёма в противоположном направлении.',
  zjbzj: 'Добавление маржи',
  zjbzjjs: 'Маржа увеличивается с пересчётом параметров позиции по взвешенной формуле.',
};

const risk = {
  fxbzj: 'Страховой фонд',
  fxbz: 'Каждая сделка под защитой от рисков',
};

const license = {
  license: 'BiKing получил лицензию MSB',
  hgyy: 'Глобальное присутствие, законная деятельность',
  login: 'Войти',
  download: 'Сканируйте для загрузки',
  support: 'Поддержка',
  jsjy: 'Мгновенные сделки в любое время',
  ljxz: 'Скачать приложение BiKing',
};

const footer = {
  yhyh: 'Самая дружелюбная к пользователю',
  jypt: 'фьючерсная платформа',
  yhzc: 'Поддержка пользователей',
  flsm: 'Комиссии',
  ggzx: 'Объявления',
  yhxz: 'Пользователям',
  tksm: 'Условия',
  fxzs: 'Предупреждение о рисках',
  xylb: 'Документы',
  gywm: 'О нас',
  gy: 'О нас',
  lxwm: 'Контакты',
  appxz: 'Скачать приложение',
  callus: 'Подпишитесь на BiKing',
  zwzxxx: 'Получайте новости, инсайты и движения цен',
  zc: 'Регистрация',
  email: 'Email',
  callingus: 'Свяжитесь с нами',
  bqsy: 'Все права защищены',
  tips: 'Инвестиционные риски: будьте осторожны при входе на рынок',
};

const card = {
  title: 'Почему мы — самая дружелюбная фьючерсная платформа',
  text: 'BiKing помогает создавать, приумножать и защищать богатство',
  djxn: 'Возврат комиссии',
  jsqd: '100% комиссии возвращается, снижая затраты и повышая прибыльность',
  zcbz: 'Быстрый ввод/вывод',
  cssbz: 'Быстрый ввод и вывод без задержек, обеспечивая безопасность и не давая упустить момент',
  gld: 'Удобно и просто',
  zxhd: 'Регистрация и открытие позиции за 10 секунд, уникальная защита конфиденциальности, простой процесс',
  qthfw: 'Круглосуточный сервис',
  kffw: 'Комфортный интерфейс, маржа в монетах, поддержка 24/7',
  bjyy: 'Удобно',
  fxkk: 'Различные типы ордеров и инструментов, риск под контролем',
  axjy: 'Торгуйте где угодно и когда угодно',
  bkms: 'BiKing доступен на веб-сайте, в мобильном приложении, API и FIX',
};

const news = {
  title: 'Новости и обзоры',
  text: 'Узнавайте о новостях и особенностях ведущей криптобиржи мира',
  sy: 'Обзоры',
  ltitle: 'Биткоин может решить уникальные задачи развивающихся рынков',
  ldesc: 'Статья в Cointelegraph. Биткоин продолжает распространяться благодаря спросу на развивающихся рынках…',
  more: 'Подробнее',
  xwfbs1: 'Пресс-релизы',
  rdesc1: 'BiKing стал спонсором Blockchain Economy Istanbul Summit 2022',
  xwfbs2: 'Пресс-релизы',
  rdesc2: 'BiKing стал спонсором Blockchain Economy Istanbul Summit 2022',
};

const info = {
  hzhb: 'Партнёры по автоматизированной торговле',
  qsjy: 'Торгуйте на BiKing с помощью торговых роботов легко',
  quadency: 'QUADENCY',
  clpt: 'Профессиональная платформа автоматических стратегий',
  stacked: 'Stacked',
  glcf: 'Пользователи могут инвестировать в криптоиндексы Stacked, автоматизировать торговлю и управлять капиталом',
};

const menu = {
  creditCardOrder: 'Оплата картой',
  ptmb: 'C2C',
  dsfjy: 'Покупка через третьих лиц',
  kjmb: 'Быстрая покупка',
  xykmb: 'Покупка по карте',
  order: 'Ордера',
  userOrder: 'Ордера пользователя',
  merchantOrder: 'Ордера продавца',
  quickOrder: 'Быстрые ордера',
  merchant: 'Продавец',
  asMerchant: 'Стать продавцом',
  advertisingManage: 'Управление объявлениями',
  financialStatements: 'Отчёты',
  messageCenter: 'Центр сообщений',
  more: 'Ещё',
  paymentSettings: 'Настройки платежей',
  publish: 'Опубликовать объявление',
  overview: 'Обзор',
  aqzx: 'Безопасность',
  phsz: 'Настройки',
  hykhj: 'Фьючерсный сезон, новая эра торговли',
  xszn: 'Гид новичка',
  bwyjy: 'Аналитический отдел BiKing',
  bwsq: 'Сообщество BiKing',
  yhxz: 'Пользователям',
  bwysp: 'Деривативы BiKing',
  jyxz: 'Правила OTC',
};

const otc = {
  Realtimequotes: 'Котировки для информации, уточняйте на сайте поставщика',
  Realtimequotes1: 'Лимит на сделку',
  Realtimequotes2: 'Ориентировочная цена',
  Realtimequotes3: 'Купить',
  Realtimequotes5: 'Введите сумму покупки',
  Realtimequotes6: 'Макс.',
  Realtimequotes7: 'Превышает макс. лимит',
  Realtimequotes8: 'Количество',
  Realtimequotes9: 'Комиссия',
  Realtimequotes10: 'Способ оплаты',
  Realtimequotes11: 'Время зачисления',
  Realtimequotes12: '10–20 минут после оплаты',
  Realtimequotes13: 'Подтвердить покупку',
  Realtimequotes14: 'Шаги покупки',
  Realtimequotes15: 'Выберите криптовалюту, фиат и поставщика',
  Realtimequotes16: 'Введите сумму, заполните данные у поставщика и оплатите',
  Realtimequotes17: 'Просматривайте купленную криптовалюту в истории пополнений BiKing',
  Realtimequotes18: 'Переход на {XXXXX} для покупки',
  Realtimequotes24: 'Внимание',
  Realtimequotes19: '{XXXXX} — независимая платформа для обмена фиата на криптовалюту, все услуги предоставляются {XXXXX}',
  Realtimequotes20: 'Ориентировочная цена включает комиссию платформы, фактическая цена — на сайте {XXXXX}',
  Realtimequotes21: 'BiKing не несёт ответственности за убытки, связанные с использованием этого сервиса.',
  Realtimequotes22: 'Понятно, перейти',
  Realtimequotes23: 'Сумма покупки',
  Realtimequotes25: 'Покупка через третьих лиц',
  Realtimequotes26: 'Пожалуйста, заполните информацию об email',
  Realtimequotes27: 'Заполнить сейчас',
  Realtimequotes28: 'Название стороннего продавца',
  XXXXX: '{pay} — независимая платформа для обмена фиата на криптовалюту, все услуги предоставляются {pay}',
  XXXX: 'Ориентировочная цена включает комиссию платформы, фактическая цена — на сайте {pay}',
  ckj: 'Ориентир ({price})',
  meBuy: 'Я покупаю',
 服务商: 'Поставщик',
  bjgq: 'Предложение устарело, обновите',
  gxbj: 'Обновить цену',
  zxkdh: 'Мин. обмен: {min} {symbol}',
  zdkdh: 'Макс. обмен: {max} {symbol}',
  Available: 'Доступно',
  Unknown: 'Неизвестно',
  qxgz: 'Правило отмены: более 200 отмен за день — ограничение покупок.',
  xncs: 'продаёт вам',
  qxzzffs: 'Выберите способ оплаты',
  qdqx: 'Подтвердить отмену',
  wzxx: 'Я подумаю',
  msk: 'Способ оплаты покупателя',
  zhmc: 'Имя счёта',
  zhxq: 'Детали счёта',
  xzhb: 'Выберите валюту',
  
  buyer: 'Покупатель',
  seller: 'Продавец',
  goSet: 'Добавить',
  addPayWayTitle: 'Добавить способ оплаты',
  addPayWay: 'Вам нужно добавить или активировать хотя бы один способ оплаты, чтобы {type} криптовалюту',
  supportPayWay: 'Вам нужно добавить и включить способы оплаты, поддерживаемые для {type}',
  top: 'Вверх',
  marginTips: 'Вы уже внесли {baseMarginPaid} USDT депозита, необходимо внести не менее {needMargin} USDT',
  eyqx: 'Более 3 отмен/апелляций в день приведут к ограничению. При злонамеренной отмене аккаунт может быть заблокирован.',
  qdbzgm: 'Отменить покупку?',
  qxbtk: 'После отмены ордера возврат не производится. Если вы уже оплатили, не отменяйте.',
  yzjbzj: 'Обычный продавец добавил депозит',
  xbjjcbzj: 'Требуется доплата базового депозита',
  jg: 'Цена',
  zxjgxd: 'Разместить по текущей цене',
  je: 'Сумма',

  ccxe: 'Превышение лимита',
  yebz: 'Недостаточно средств',
  qxsm: 'Пройдите верификацию',

  dfb: 'Ожидание выпуска',
  jywc: 'Сделка завершена',
  buy: 'Купить',
  sell: 'Продать',
  coin: 'Монета',
  allCoin: 'Все монеты',
  frenchCurrency: 'Фиат',
  payWay: 'Способ оплаты',
  all: 'Все',
  bankCard: 'Банковская карта',
  zfb: 'Alipay',
  wx: 'WeChat',
  search: 'Поиск',
  merchant: 'Продавец (30д сделок / процент выполнения)',
  turnover: 'Объём',
  completionRate: '% выполнения',
  quotaOrNumber: 'Количество / Лимит',
  number: 'Количество',
  quota: 'Лимит',
  price: 'Цена',
  paymentMethod: 'Способ оплаты',
  trade: 'Сделка',
  handlingFee: '0 комиссии',
  buyUsdt: 'Купить USDT',
  sellBtc: 'Продать USDT',
  theRemainingAmount: 'Остаток',
  userRealName: 'Имя пользователя',
  businessMessage: 'Сообщение продавца',
  wantPay: 'Я оплачиваю',
  wantSell: 'Я продаю',
  receive: 'Я получу',
  password: 'Пароль',
  pleaseEnterPassword: 'Введите пароль',
  cancel: 'Отмена',
  buyUSDT: 'Купить USDT',
  sellUSDT: 'Продать USDT',
  Paymentchannel: 'Платёжный канал (ориентируйтесь на курс поставщика)',
  lumpSum: 'Итого',
  agree: 'Продолжая C2C-сделку с BiKing, вы принимаете',
  mzsm: 'Юридический отказ от ответственности BiKing C2C',
  quit: 'Выйти',
  confirm: 'Подтвердить',
  orderDetail: 'Детали ордера',
  limitExceeded: 'Превышение лимита',
  quantityRemaining: 'Недостаточно остатка',

  cryptoTitle: 'Купить USDT легко за несколько шагов',
  cryptoSubTitle: 'Безопасная фьючерсная платформа',
  availableBalance: 'Доступно',
  sellAll: 'Продать всё',
  fundsTransfer: 'Перевод средств',
  threeStep: 'Купить криптовалюту за 3 шага',
  advantage: 'Преимущества покупки/продажи криптовалюты на BiKing',
  commonQuestion: 'Часто задаваемые вопросы',
  otc_title: 'Покупайте/продавайте криптовалюту через C2C с 0% комиссии',
  otc_title1: 'Безопасно и легко на BiKing. Торгуйте USDT через банковский перевод, кредитную карту и другие способы.',
  commonQuestion1: 'Что такое C2C-торговля криптовалютой?',
  commonQuestion2: 'Сколько стоит C2C-торговля?',
  commonQuestion3: 'Кто такие продавцы на C2C BiKing?',
  commonQuestion4: 'Зарабатывают ли продавцы на C2C BiKing?',
  commonQuestion5: 'Как избежать мошенничества в C2C?',
  commonQuestion1_desc: 'C2C — это прямой обмен криптовалютой между пользователями без посредника (биржи).',
  commonQuestion2_desc: 'Стоимость зависит от платформы, сети и монеты. На BiKing C2C — 0% комиссии.',
  commonQuestion3_desc: 'Продавцы C2C BiKing — верифицированные пользователи, размещающие объявления о купле/продаже.',
  commonQuestion4_desc: 'Прибыль продавца зависит от стратегии, частоты, спреда и рыночных условий.',
  commonQuestion5_desc: 'Проверяйте личность, используйте безопасную платформу, не делитесь лишней информацией, используйте отслеживаемые платежи.',
  register: 'Регистрация',
  registerByPhone: 'Зарегистрироваться по email или телефону',
  authentication: 'Верификация',
  authenticationId: 'Пройдите верификацию с удостоверением личности',
  buyCoins: 'Купить криптовалюту',
  buyCoinsByCard: 'Купить криптовалюту картой или банковским переводом',
  fast: 'Быстро и удобно',
  easyUse: 'Простая покупка',
  fastPayment: 'Зачисление за несколько минут.',
  multiplePayment: 'Множество способов оплаты',
  platformSupports: 'Платформа поддерживает различные способы оплаты',
  flexibleConvenient: 'Обеспечивает гибкость и удобство.',
  safeReliable: 'Безопасно и надёжно',
  measure: 'Многоуровневые меры безопасности',
  informationSecurity: 'Гарантия безопасности средств и данных пользователя.',
  questionTitle1: '1. О бирже BiKing',
  questionSubTitle1: 'BiKing — ведущая сингапурская платформа с лицензиями MSB США и Канады.',
  questionTitle2: '2. Какие продукты предлагает BiKing?',
  questionSubTitle2: 'Бессрочные контракты, спот (0 комиссии), копитрейдинг, бонусная торговля, веб-кошелёк.',
  questionTitle3: '3. Как зарегистрироваться?',
  questionSubTitle3: 'На сайте или в приложении BiKing.',
  questionTitle4: '4. Как купить криптовалюту?',
  questionSubTitle4: 'Быстрая покупка за фиат поддерживает множество способов и валют.',
  questionTitle5: '5. Как торговать?',
  questionSubTitle5: 'Выберите актив → выберите покупку/продажу → введите количество и цену → подтвердите.',
  questionTitle6: '6. Как BiKing обеспечивает безопасность?',
  questionSubTitle6: 'Многоуровневое шифрование, холодное/горячее хранение.',
  
  orderType: 'Тип ордера',
  orderStatus: 'Статус ордера',
  to: 'до',
  startTime: 'Начальная дата',
  endTime: 'Конечная дата',
  orderNo: 'Номер ордера',
  status: 'Статус',
  totalPrice: 'Общая сумма',
  numberOrFee: 'Количество / Комиссия',
  tradingPartners: 'Контрагент',
  time: 'Время',
  operate: 'Действие',
  details: 'Детали',
  noPay: 'Ожидает оплаты',
  payed: 'Оплачено',
  finish: 'Завершено',
  canceled: 'Отменено',
  complaint: 'В процессе спора',
  legalCurrency: 'Сумма в фиате',
  virtualCurrency: 'Криптовалюта',
  virtualCurrencyAddress: 'Адрес получения',
  paymenttype: 'Тип платежа',
  creatTime: 'Время создания',
  success: 'Успех',
  pending: 'В обработке',
  awaiting: 'Ожидает подтверждения',
  declined: 'Отказ',

  mjskfs: 'Способ оплаты продавца',
  mjfkfs: 'Способ оплаты покупателя',
  toPay: 'Оплатить',
  ddzdqx: 'Если вы не выберете способ оплаты в течение {payTime}, ордер будет автоматически отменён.',
  paying: 'Контрагент оплачивает...',
  fkckh: 'Код платежа:',
  dfwfkqx: 'Если контрагент не оплатит в течение {payTime}, ордер будет отменён автоматически.',
  ddqxwfck: 'Ордер отменён, информация об оплате недоступна.',
  ddqxckh: 'Ордер отменён, код платежа:',
  ssz: 'Спор, пожалуйста, подождите. Код платежа:',
  qxss: 'Отменить спор',
  xzfkfs: 'Вы выбрали способ оплаты',
  ddywc: 'Ордер завершён',
  ss: 'Спор',
  wcfqss: '* Спор можно начать через 1 минуту после завершения ордера.',
  bnfqss: '* Спор нельзя начать через {time} часов после завершения.',
  zxkf: '* После OTC-покупки вывод доступен через T+1 день. Обратитесь в поддержку при вопросах.',
  sjyjn: 'Депозит продавца: {deposit} {depositName}',
  wen1: '1. Когда я получу деньги?',
  da1: 'После оплаты вы получите уведомление.',
  wen2: '2. Покупатель не оплатил. Что делать?',
  da2: 'Продавец не может отменить ордер. При длительном ожидании — обратитесь в поддержку.',
  wen3: '3. Что будет, если не подтвердить выпуск вовремя?',
  da3: 'Задержка может привести к спору и потере репутации; средства останутся замороженными.',
  wen4: '4. Важно о получении оплаты',
  da4: '1) Убедитесь, что деньги действительно получены, не верьте на слово. Нажимайте «подтвердить» только после фактического получения!<br/>2) Если банковский счёт покупателя не совпадает с именем на платформе — будьте осторожны, при сомнениях обращайтесь в поддержку.',
  qzgdsjnzf: 'Ожидает оплаты. Пожалуйста, переведите {totalAmounts} {fiatCurrency} продавцу {associatedAdMerchantNickname} в течение {payTime}. Код платежа:',
  nxdfgm: 'Вы покупаете {amount_s} {coinsName} у {associatedAdMerchantNickname} ({realName})',
  dfxngm: '{userNickName} ({realName}) покупает у вас {amount_s} {coinsName}',
  nxdfcs: 'Вы продаёте {amount_s} {coinsName} {associatedAdMerchantNickname} ({realName})',
  dfxncs: '{userNickName} ({realName}) продаёт вам {amount_s} {coinsName}',
  payed: 'Оплачено',
  dddffx: 'Ожидаем подтверждения от контрагента...',
  njhdq: 'Вы получите {quantity}{coinsName}',
  qxdd: 'Отменить ордер',
  kfqss: 'Если через {complaintPayed} минут после оплаты продавец не выпустит монеты, можно начать спор.',
  yfkfkckh: 'Контрагент оплатил. Код платежа:',
  qjkqrsk: 'Пожалуйста, подтвердите получение',
  ddnsk: 'Ожидаем подтверждения от вас',
  zfje: 'Сумма платежа',
  skzh: 'Счёт получения:',
  fkzhxm: 'Имя плательщика:',
  qdskh: '* Убедитесь, что деньги реально получены на ваш платёжный инструмент, прежде чем подтверждать.',
  fbl: 'Выпустить',
  dfyqrfk: '* Контрагент подтвердил оплату. Если через {complaintPayed} минут вы не получили деньги, можно начать спор.',
  jkcssk: '* Если прошло более 24 часов с подтверждения оплаты, начать спор нельзя.',
  qrfb: 'Подтвердить выпуск',
  qwbqr: 'Убедитесь, что вы действительно получили деньги (сумму верна) перед выпуском монет.',
  wyqrskzq: 'Я подтверждаю получение и правильность суммы',
  tjssyy: 'Укажите причину спора',
  srssyy: 'Введите причину спора',
  sctpxt: 'Загрузить фото (необязательно)',
  upload: 'Загрузить',
  zdscsz: '* Максимум 3 фото, формат jpeg/jpg/png, не более 3 МБ.',
  sstj: 'Отправить',

  qrfk: 'Подтвердить оплату',
  fkje: 'Сумма оплаты',
  sdzz: '* Платформа не списывает средства автоматически. Вы должны перевести их самостоятельно со своего счёта и обязательно нажать кнопку «Я оплатил». Если вы не нажмёте, потери лягут на вас.',
  bzts: '* Не указывайте в комментарии к переводу «BTC», «USDT», «BiKing» и т.п., иначе продавец может отказать.',
  wfk: 'Не оплачено',
  w: 'Я',
  srxxfs: 'Введите сообщение, Enter для отправки',
  dan: 'сделка',
  bnch: 'Нельзя добавить более одного способа оплаты одного типа',
  sd: 'Мгновенный обмен',
  from: 'Отдаёте',
  to: 'Получаете',
  rate: 'Курс',
  successful: 'Обмен успешен',
  fees: 'Комиссия',
  slippage: 'Проскальзывание',
  standards: 'Ставка комиссии',
  transactionamount: '{num}% от суммы сделки',
  confirm: 'Подтвердить обмен',
  records: 'Все записи обмена',
  tocurrency: 'Расходуемая монета',
  consumption: 'Сумма расхода',
  Getcurrency: 'Получаемая монета',
  GetQuantity: 'Сумма получения',
  ExchangeStatus: 'Статус обмена',
  Exchangetime: 'Время обмена',
  Youwillconsume: 'Вы потратите',
  YouwillGET: 'Вы получите',
  Updatequote: 'Обновить котировку',
  Failed: 'Ошибка обмена',
  Consumption: 'Канал расхода',
  Completed: 'Завершено',
  chaeckrecords: 'Смотреть все записи обмена ›',
  Converted: 'Вы успешно обменяли {aaa} на {bbb}',
  recommend: 'Рекомендуем',
  wcsj: "Время завершения",
};

const otcMerchant = {
  bzj: 'Депозит',
  mmggs: 'Кол-во объявлений (покупка/продажа)',
  bx: 'Не ограничено',
  ggzed: 'Общий лимит объявлений',
  kzjgged: 'Доступно для увеличения лимита',
  zjbzjbs: 'Коэффициент увеличения депозита',
  tbzss: 'Показано 10',

  tjsjsqb: 'Подать заявку на статус продавца',
  wcgjkycrz: 'Пройдите расширенную KYC',
  ynlx: 'После проверки формы с вами свяжется OTC-специалист',

  zbzl: 'Подготовьте документы',
  kssh: 'Быстрая проверка',
  
  h1: 'Интеллектуальная торговля',
  h2: 'Станьте экспертом C2C',
  h3: 'Скоро вы станете верифицированным продавцом',
  sjqy: 'Привилегии продавца',
  c2cjy: '<span>0% комиссии</span> в C2C и другие привилегии',
  fbq: 'Ваша фиат-зона',
  ptsj: 'Обычный продавец',
  xsqy: 'Станьте верифицированным продавцом, получайте больше привилегий',
  wtd: 'После одобрения заявки можно публиковать ордера',
  xjn: 'Требуется депозит {deposit}',
  ljsq: 'Подать заявку',
  cwptsj: 'Вы стали обычным продавцом',
  cwrzsj: 'Вы стали верифицированным продавцом',
  rzsj: 'Верифиц. продавец',
  xrd: 'Наивысшая степень доверия на рынке',
  nbyq: 'Только по приглашению Biking',
  rzbs: 'Эксклюзивный статус верифицированного продавца',
  pmq: 'Приоритет в рейтинге',
  kffw: 'Персональная поддержка 1 на 1',
  sjxy: 'OTC-соглашение ({level})',
  xsjc: 'Руководство для начинающих',
  jygz: 'Правила торговли',
  close: 'Закрыть',
  submited: 'Заявка подана',
  submitSuccess: 'Заявка успешно подана',

  sqsj: 'Стать продавцом',
  fwxy: 'Соглашение об услугах для продавцов Biking',
  xyb: 'Данное соглашение заключается между вами и Biking. Регистрируясь, вы принимаете все условия.',
  ptsm: 'Заявление платформы:',
  p1: '1. Платформа только предоставляет место для торговли и информацию, не участвуя в сделках. Ответственность за проверку данных лежит на сторонах.',
  p2: '2. Любая информация не является инвестиционной рекомендацией. Мы не несём ответственности за убытки, связанные с её использованием.',
  p3: '3. Содержимое может меняться без уведомления. Мы не гарантируем точность и не несём ответственности за задержки или сбои связи.',
  p4: '4. Риски интернет-систем (сбои ПО/аппаратуры/связи). Мы не несём ответственности за искажения, задержки или сбои соединения.',
  p5: '5. Запрещено использовать платформу для отмывания денег, контрабанды, взяток и прочих незаконных действий. Нарушение влечёт блокировку счёта и уведомление властей.',
  p6: '6. Запрещён недобросовестный доступ к рынку. Нарушения влекут предупреждение, ограничения или блокировку счёта.',
  p7: 'Вы соглашаетесь с данными условиями при регистрации.',
  zcbzj: 'Статья 1: Депозит',
  p8: '1. После прохождения KYC и проверки на отмывание денег платформа требует внесения депозита для обеспечения безопасности сделок.',
  p9: '2. Сумма депозита отображается в фиатных активах продавца и в процессе торговли.',
  p10: '3. Депозит может быть заморожен на ≥1 месяц в следующих случаях:',
  p11: '1) Спор, признана вина продавца, отказ от обязательств;',
  p12: '2) Сделка с неверифицированным аккаунтом;',
  p13: '3) Использование платформы для незаконных действий;',
  p14: '4) Нарушение соглашения или правил;',
  p15: '5) Склонение пользователей к уходу на другую платформу;',
  p16: '6) Склонение к ложной регистрации для получения бонусов;',
  p17: '7) Склонение пользователей партнёров к уходу на другую платформу.',
  cxzg: 'Статья 2: Лишение статуса продавца',
  p18: 'Платформа может лишить статуса продавца в случае:',
  p19: '1. Многократных жалоб пользователей;',
  p20: '2. Предоставления ложных данных в заявке;',
  p21: '3. Мошенничества или недобросовестности в сделках;',
  p22: '4. Несотрудничества с поддержкой или намеренных задержек;',
  p23: '5. Злонамеренного использования правил платформы;',
  p24: '6. Нарушения законов, соглашения или правил;',
  p25: '7. Действий, противоречащих добросовестной торговле;',
  p26: '8. Иных нарушений законов.',
  zlbh: 'Статья 3: Конфиденциальность данных продавца',
  p27: '1. Данные, предоставленные при подаче заявки, сохраняются платформой. Мы не разглашаем их, за исключением случаев: по вашему поручению;',
  p28: '2. По запросу госорганов;',
  p29: '3. Аффилированным лицам;',
  p30: '4. Третьим лицам, совместно предоставляющим услуги;',
  p31: '5. При разрешении спора с третьей стороной.',
  sjcn: 'Статья 4: Обязательства продавца',
  p32: '1. Принятие полных условий — необходимое условие для заявки.',
  p33: '2. Вы не будете использовать заявку в незаконных или запрещённых целях.',
  p34: '3. Вы не будете злонамеренно вмешиваться в работу сайта или услуг.',
  p35: '4. Вы не будете пытаться получить данные несанкционированным способом.',
  p36: '5. Вы подтверждаете, что используете сайт не для нарушения законов.',
  p37: '6. Продавец обязуется раскрывать информацию по запросу платформы.',
  ptmz: 'Статья 5: Отказ от ответственности платформы',
  bcfx: 'Платформа не несёт ответственности в следующих случаях:',
  p38: '1. Разглашение данных из-за передачи пароля или небрежного хранения.',
  p39: '2. Действия хакеров, вирусов, сбои связи, форс-мажор.',
  p40: '3. Утечка данных через сторонние сайты (например, интернет-банкинг).',
  p41: '4. Предоставление неверной или неполной информации.',
  p42: '5. Мошенничество с вашими активами не по вине платформы.',
  ptts: 'Статья 6: Важные замечания',
  p43: '1. Сайт может содержать ссылки на сторонние ресурсы (например, онлайн-банкинг). Мы не несём ответственности за их содержимое.',
  p44: '2. Платформа предоставляет только услуги площадки и не является участником сделок; мы не осуществляем ввод/вывод фиатных денег.',
  p45: '3. Используя сайт, вы принимаете все условия соглашения с учётом будущих изменений.',
  p46: '4. Нажатие кнопки «Согласен» или использование услуг означает принятие условий в полном объёме.',
  p47: '5. Мы оставляем за собой право изменять соглашение с уведомлением на сайте.',
  tyxy: 'Я согласен с условиями',
  nextStep: 'Далее',
};

const user = {
  txxz: 'Изменение платёжного пароля блокирует вывод на 24 часа',
  name: 'Никнейм',
  rzdj: 'Уровень верификации',
  phone: 'Телефон',
  email: 'Email',
  zzc: 'Оценка активов',
  hours24: '24 часа',
  market: 'Рыночные данные',
  notice: 'Объявления',
  more: 'Ещё >>',
  cb: 'Пополнить',
  tb: 'Вывести',
  hz: 'Перевести',
  wsm: 'Не верифицирован',
  cjrz: 'Базовая верификация',
  gjrz: 'Расширенная верификация',
  qwgjrz: "Пройти расширенную верификацию",
  aqszx: 'Настроенные параметры безопасности',
  xgaqszx: 'Изменить настройки безопасности',
  dlmm: 'Пароль входа',
  zjdl: 'Установив пароль входа, вы сможете входить по нему.',
  ghmm: 'Сменить пароль',
  sz: 'Установить',
  jymm: 'Торговый пароль',
  yzjymm: 'При движении средств требуется проверка торгового пароля.',
  ghjymm: 'Сменить торговый пароль',
  sjyz: 'Верификация по телефону',
  yzdx: 'Для входа, вывода, смены пароля и настроек безопасности.',
  xgsj: 'Изменить номер телефона',
  zwbd: 'Не привязан',
  ggyz: 'Google Authenticator',
  syzn: 'Руководство',
  bd: 'Привязать',
  yxyz: 'Верификация по email',
  tbqr: 'Можно привязать email для входа, восстановления пароля, вывода.',
  bdyx: 'Привязать email',
  xgyx: "Изменить email",
  xyx: "Новый email",
  dljl: 'Последние 10 записей входа',
  zjdljl: 'Ваши последние 10 входов',
  dlsj: 'Последний вход',
  ip: 'IP-адрес',
  aqsz: 'Настройки безопасности',
  yhdl: 'Вход пользователя',
  xgbdsj: 'Изменить привязанный телефон',
  bdsj: 'Привязать телефон',
  dxyzm: 'СМС-код',
  second: 'сек',
  fsyzm: 'Отправить код',
  xsjh: 'Новый номер телефона',
  ggyzm: 'Код Google Authenticator',
  yxyzm: 'Код подтверждения email',
  confirm: 'Подтвердить',
  edit: 'Изменить',
  name: 'Имя',
  srxm: 'Введите имя',
  zjlx: 'Тип документа',
  xzzjlx: 'Выберите тип документа',
  zjhm: 'Номер документа',
  srzjhm: 'Введите номер документа',
  zcsr: 'Повторите пароль',
  mmbyz: 'Пароли не совпадают!',
  sfz: 'Паспорт РФ / удостоверение личности',
  jgz: 'Военный билет',
  hz: 'Загранпаспорт',
  jmtxz: 'Разрешение на жительство (Тайвань)',
  gatxz: 'Разрешение на жительство (Гонконг, Макао)',
  hwid: 'Иностранный ID',
  srdx: 'Введите СМС-код',
  sryx: 'Введите код из email',
  srgg: 'Введите код Google Authenticator',
  jdlmm: 'Старый пароль входа',
  xdlmm: 'Новый пароль входа',
  qrxmm: 'Подтвердите новый пароль',
  qrdlmm: 'Подтвердите пароль входа',
  jjymm: 'Старый торговый пароль',
  xjymm: 'Новый торговый пароль',
  qrjymm: 'Подтвердите торговый пароль',
  qwcyz: 'Завершите проверку',
  smrz: 'Пройдите верификацию',
  sryzm: 'Введите код подтверждения',
  srsjh: 'Введите номер телефона',
  xgdlmm: 'Изменить пароль входа',
  szdlmm: 'Установить пароль входа',
  xgjymm: 'Изменить торговый пароль',
  szjymm: 'Установить торговый пароль',
  czmm: 'Сбросить пароль',
  
  bdgg: 'Привязать Google Authenticator',
  lbyzq: 'Загрузите приложение двухфакторной аутентификации Google',
  smewm: 'Отсканируйте QR-код',
  srdm: 'Если QR-код не читается, введите код вручную',
  copy: 'Копировать',
  copySuccess: 'Скопировано',
  sryx: 'Введите email',
  srzqyx: 'Введите корректный email',
  srsjyzm: 'Введите СМС-код',
  sryxyzm: 'Введите код из email',
  srggyzm: 'Введите код Google Authenticator',
  passwordTypeError: 'Пароль должен быть 8–32 символа, включать заглавные и строчные буквы и цифры.',
  passwordDiff: 'Пароли не совпадают',
  zcsrxmm: 'Повторите пароль',
  language: 'Язык',
  bdhb: 'Локальная валюта',
  wdbph: 'Предпочтение стейблкоинов',
  
  相关问题: "Часто задаваемые вопросы",
  为什要进行身份认证: "Зачем нужна верификация?",
  上传中: "Загрузка...",
  开始上传: "Начать загрузку",
  录制第一段视频: "Записать первое видео",
  录制第二段视频: "Записать второе видео",
  录制完成: "Запись завершена",
  请手持身份证正面: "Держите удостоверение личности лицевой стороной к камере",
  正对摄像头: "Смотрите в камеру не менее 5 секунд",
  摘下眼镜: "Снимите очки, головные уборы и т.п.",
  请按视频文字提示录制视频: "Следуйте инструкциям на экране",
  开始录制: "Начать запись",
  第一段视频: "Первое видео",
  第二段视频: "Второе видео",
  录制一段视频: "Записать одно видео",
  点击开始录制: "Нажмите для начала записи",
  视频录像认证: "Видеозапись",
  身份证号: "Номер ID",
  证件验证: "Проверка документа (фото/скан)",
  zjyz: "Проверка документа",
  请确保图片格式为: "Формат jpg/jpeg/png, размер не более 2 МБ",
  请手持证件照: "Фото с документом и рукописной подписью: Biking + текущая дата",
  当日签名照: "Фото с документом и подписью",
  上传证件签名页: "Загрузить фото с подписью",
  请保证所有信息清晰: "Вся информация должна быть чёткой",
  上传证件页信息: "Загрузить фото документа",
  请选择国家: "Выберите страну",
  请上传正面证件照: "Загрузите лицевую сторону",
  请上传反面证件照: "Загрузите обратную сторону",
  手持证件照: "Фото с документом",
  请选择区域: "Выберите регион",
  认证要求: "Требования",
  证件信息: "Данные документа",
  人脸识别: "Распознавание лица",
  立即认证: "Пройти верификацию",
  什么是加密货币P2P交易: "Что такое P2P-торговля криптовалютой?",
  最好的P2P加密货币交易所是什么: "Какая лучшая P2P-биржа?",
  P2P交易的成本有多少: "Сколько стоит P2P-торговля?",
  什么是BikingP2P上的商家: "Кто такие продавцы на Biking P2P?",
  我们正在审核您的申请: "Ваша заявка на проверке",
  预计审核时间: "Ожидаемое время проверки: 72 часа",
  驳回: "Отклонено",
  未提交: "Не подано",
  手续费等级: "Уровень комиссии",
  去认证: "Пройти верификацию",
  已认证: "Верифицирован",
  开通更多权限: "Верифицируйтесь для большего",
  在别人贪婪时要保持警惕: "Будьте жадны, когда другие осторожны, и осторожны, когда другие жадны — Уоррен Баффет",
  kyc声明: 'Я {Name}, номер документа: {No}. Я добровольно регистрируюсь и торгую на Biking, гарантирую использование аккаунта лично, легальность источников средств, принимаю все торговые риски, не буду использовать выведенные средства незаконно и не буду участвовать в незаконной деятельности (отмывание денег, финансовые пирамиды, нелегальный обмен валюты).',
  编辑头像: "Редактировать аватар",
  请选择一个头像用作您个人资料的照片: "Выберите аватар для профиля",
  中国: "Китай",
  其他: "Другая",
  questionTitle1: '1. Почему нужна верификация?',
  questionSubTitle1: 'BiKing использует глобальную верификацию для безопасности средств. Пожалуйста, предоставьте корректные данные.',
  questionTitle2: '2. Зачем проходить верификацию?',
  questionSubTitle2: 'Для доступа к OTC-функциям требуется верификация. Без неё доступны только операции в блокчейне.',
  questionTitle3: '3. Как обновить верификацию?',
  questionSubTitle3: 'Если данные изменились при определённых условиях (см. список), обратитесь в поддержку.',
  questionTitle4: '4. Сколько времени занимает KYC?',
  questionSubTitle4: 'Обычно до 5 минут, но иногда дольше.',
  questionTitle5: '5. Безопасна ли верификация?',
  questionSubTitle5: 'Да, она помогает создать безопасную платформу. Данные конфиденциальны.',
  questionTitles: '1. Документ просрочен;',
  questionTitles1: '2. Изменилось имя на документе;',
  questionTitles2: '3. Изменился номер документа;',
  questionTitles3: '4. Сменилось гражданство;',
  questionTitles4: '5. Обновление документа для использования фиатных операций;',
  questionTitles5: '6. Изменение имени для соответствия системному языку (например, с национального на паспорт);',
  Z1001: "Системная ошибка",
  Z1003: "Проверка прервана",
  Z2002: "Ошибка сети",
  Z2003: "Ошибка времени на устройстве",
  Z2006: "Ошибка верификации",
  Z5050: "Распознавание лица успешно",
  Z5051: "Ошибка загрузки фото",
  Z5052: "Ошибка данных",
  Z5053: "Ошибка сети",
  Z5054: "Нет доступа к камере",
  Z5055: "Выход пользователя",
  Z5056: "Слишком много попыток",
  Z5057: "Тайм-аут загрузки видео",
  Z5058: "Неверный формат видео",
  Z5059: "Лицо не обнаружено",
  Z5128: "Лица не совпадают",
  法币充值: 'Пополнение и вывод фиата',
  无限额: 'Без лимита',
  数字货币充值: 'Пополнение криптовалюты',
  数字货币提现限额: 'Лимит вывода криптовалюты',
  C2C交易限额: 'Лимит C2C-торговли',
  "参数不合法": 'Неверный параметр',
  h5smrz: "Верификация",
  bhzhan: "Установите пароль для защиты аккаунта",
  jxsmrz: "Пройдите верификацию для безопасности средств",
  qwrz: "Пройти верификацию",
  dgzhzd: "1. Максимум 5 попыток в день",
  rhzp: "2. Загруженные фото/видео не хранятся",
  sfzm: "Удостоверение личности",
  zjqfg: "Страна выдачи",
  dw: "Местоположение",
  sfxx: "Личные данные",
  dqdw: "Текущее местоположение",
  gjdq: "Страна/регион",
};

const h5 = {
  chart: 'График',
  mmp: 'Стакан',
  sscj: 'Сделки',
  wt: 'Ордера',
  lswt: 'История ордеров',
  zj: 'Средства',
  sj: 'Рынок',
  ky: 'Доступно',
  zczh: 'Всего',
  dj: 'Заморожено',
  zwsj: 'Нет данных',
  zx: 'Избранное',
  buysell: 'Купить/Продать',
};

export {
  games,
  h5,
  trading,
  download,
  login,
  user,
  advertise,
  otcMerchant,
  otc,
  menu,
  time,
  state,
  text,
  seckillRes,
  header,
  hyy,
  index,
  indexPage,
  Verification,
  NAVS,
  FOOTERS,
  SIDEBAR,
  seckill,
  apply,
  recommend,
  market,
  banner,
  card,
  news,
  info,
  navCard,
  choice,
  plat,
  risk,
  license,
  footer,
  merchandiser,
  codeInfo,
  placeOrder,
  tableList,
  codelist,
  contractHyy,
  common,
  dialog,
  panKou,
  invite,
  property,
  contest,
  taskCenter,
  ieo,
  earn,
  tradingContest,
  agent,
  live,
  hongbao
};


// WEBPACK FOOTER //
// ./src/i18n/lang/public/ru.js